import React , { useState , useEffect  } from 'react'
import { Button, Modal, ModalHeader, ModalBody, Label, UncontrolledTooltip, Input, Row, Col, Accordion, AccordionItem,Collapse, ListGroup  } from 'reactstrap';
import classnames from "classnames";
import { fetch_chart_options } from '../../helpers/fakebackend_helper';
import Loader from '../../Components/Common/Loader';
import Dashboard_Favprompt_Item from './Dashboard_Favprompt_Item';
function AccordionItem_Component({ category ,  prompts }) {

      const [col1, setcol1] = useState(false);
        const [selectedChart , setselectedChart ] = useState('bar')
        const [xaxis_yaxis, setxaxis_yaxis] = useState(null)
        const [pie_chart_options_values, set_pie_chart_options_values] = useState(null)
        const [selected_xaxis, setselected_xaxis] = useState(null)
        const [selected_yaxis, setsetselected_yaxis] = useState(null)
        const [selected_labelling, setsetselected_labelling] = useState(null)
        const [selected_theta, setsetselected_theta] = useState(null)
        const [loading, setloading] = useState(false)

          const t_col1 = () => {
                setcol1(!col1);
            };


           
            


    
  return (
    <AccordionItem>
                                <h2 className="accordion-header" id="headingOne">
                                    <button
                                        className={classnames("accordion-button", { collapsed: !col1 })} type="button" onClick={t_col1} style={{ cursor: "pointer" }} >
                                        {category}
                                    </button>
                                </h2>

                                <Collapse isOpen={col1} className="accordion-collapse" id="collapseOne" >
                                    {loading? <Loader/>:
                                    <div className="accordion-body">
                                        <div className="">
                                         
                                            <ListGroup>
                                            {
                                                prompts.map((ele, key)=>{
                                                    return   <Dashboard_Favprompt_Item data={ele} key={key} />
                                                })
                                            }
                                          </ListGroup>
                                        </div>                                        
                                    </div>}
                                </Collapse>
                            </AccordionItem>
  )
}

export default AccordionItem_Component